import { SkeletonPropertiesType } from "@website/ui/skeleton/skeleton.types";
import { FC, memo } from "react";

const SHAPE_CLASSES = {
  circle: "rounded-full",
  square: "rounded-[4px]",
  rectangle: "rounded-[4px]"
} as const;

const Skeleton: FC<SkeletonPropertiesType> = ({
  className,
  shape = "rectangle",
  height,
  width,
  margin
}) => {
  const shapeClass = SHAPE_CLASSES[shape] || SHAPE_CLASSES.rectangle;
  const isSquareOrCircle = shape === "circle" || shape === "square";

  return (
    <div
      className={`bg-outline-thin relative w-full animate-pulse overflow-hidden ${shapeClass} ${className}`}
      style={{
        height: height ? `${height}px` : "100%",
        width: isSquareOrCircle ? `${height}px` : width ?? "100%",
        margin
      }}
    />
  );
};

const SkeletonMemoized = memo(Skeleton);
export { SkeletonMemoized as Skeleton };
